import { Flex } from '@modusign/design-system';

function ModalCloseButton({ ...props }) {
  return (
    <Flex
      alignItems="center"
      height="24px"
      justifyContent="center"
      sx={{
        transform: 'translate(27px, -27px)',
        '&:hover': {
          bg: 'buttonBackgroundNeutralSlightlyDark',
          borderRadius: '3px',
          cursor: 'pointer',
        },
      }}
      width="24px"
      {...props}
    >
      <svg
        fill="none"
        height="12"
        viewBox="0 0 12 12"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2734 9.97656C11.7305 10.3984 11.7305 11.1367 11.2734 11.5586C11.0625 11.7695 10.7812 11.875 10.5 11.875C10.1836 11.875 9.90234 11.7695 9.69141 11.5586L6 7.86719L2.27344 11.5586C2.0625 11.7695 1.78125 11.875 1.5 11.875C1.18359 11.875 0.902344 11.7695 0.691406 11.5586C0.234375 11.1367 0.234375 10.3984 0.691406 9.97656L4.38281 6.25L0.691406 2.55859C0.234375 2.13672 0.234375 1.39844 0.691406 0.976562C1.11328 0.519531 1.85156 0.519531 2.27344 0.976562L6 4.66797L9.69141 0.976562C10.1133 0.519531 10.8516 0.519531 11.2734 0.976562C11.7305 1.39844 11.7305 2.13672 11.2734 2.55859L7.58203 6.28516L11.2734 9.97656Z"
          fill="#848484"
        />
      </svg>
    </Flex>
  );
}

export default ModalCloseButton;
